/**
 * The retired noun forms for the daily tracking feature. Members hear the
 * feature called "tracking"; "check-in" and its closed and plural forms name
 * the same thing and must not reach them. One definition backs the authored-
 * source guard and the transcript eval, so the two cannot drift apart.
 *
 * ADR-155 states the rule and names the guard that reads this module.
 */
export const RETIRED_TRACKING_TERMS = ['check-in', 'check-ins', 'checkin', 'checkins'] as const;

// Hyphen, non-breaking hyphen, figure dash, en and em dash, horizontal bar and
// minus sign all render as a hyphen to a reader, so each counts as one here.
// Every replacement is one code unit for one code unit, so match offsets in
// the folded text line up with the original.
const HYPHEN_LIKE = /[‐-―−]/gu;

// `_` and alphanumerics are not boundaries, so contract identifiers such as
// `get_check_ins` and `daily_checkin_reminder` never match. The spaced verb
// ("check in on them") has a space where this needs a hyphen or nothing.
const RETIRED_FORM = /(?<![A-Za-z0-9_])check(-?)ins?(?![A-Za-z0-9_])/gi;

/**
 * Every retired noun form in `text`, as written (with dash variants folded to
 * a hyphen). A closed form in camelCase (`checkIns`) is an identifier, not
 * copy, and is skipped.
 */
export function findRetiredTrackingTerms(text: string): string[] {
  const folded = text.replace(HYPHEN_LIKE, '-');
  const hits: string[] = [];
  for (const match of folded.matchAll(RETIRED_FORM)) {
    const [form, hyphen] = match;
    const camelCase = hyphen === '' && form[4] === 'k' && form[5] === 'I';
    if (!camelCase) hits.push(form);
  }
  return hits;
}
